export default "__VITE_ASSET__BTrXlvRw__"